import { useState } from 'react'
import { ButtonGroup, Card, CardBody, Col, Dropdown, DropdownMenu, DropdownToggle, Input, InputGroup, InputGroupText } from 'reactstrap';
import { Inputs, WithInputTypes } from '../../../../utils/Constant';
import { withInputData } from '../../../../Data/Ui-Kits/Dropdown/Dropdown';
import { LI } from '../../../../AbstractElements';
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader';

const WithInputType = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col xl="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={WithInputTypes} span={withInputData} />
        <CardBody>
          <div className="common-flex">
            <ButtonGroup>
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle className='text-white'  caret color="warning">{Inputs}</DropdownToggle>
                <DropdownMenu className="dropdown-block dropdown-wrapper dark-input-type">
                  <LI>
                    <InputGroup className="rounded-0 border-0 shadow-none">
                      <InputGroupText>
                        <Input className="mt-0" type="checkbox"/>
                      </InputGroupText>
                      <span>Default checkbox</span>
                    </InputGroup>
                    <InputGroup className="rounded-0 border-0 shadow-none">
                      <InputGroupText>
                        <Input className="mt-0" type="radio"/>
                      </InputGroupText>
                      <span>Default radio</span>
                    </InputGroup>
                  </LI>
                </DropdownMenu>
              </Dropdown>
            </ButtonGroup>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default WithInputType